import type { TCustomerData } from 'shared/types';

import type { TCreditFormCommonFields } from 'entities/creditForm';

export const convertJobTitleField = (data: Partial<TCustomerData>): TCreditFormCommonFields['jobTitle'] => {
  const { jobTitle, jobType } = data;
  if (!jobTitle) {
    return null;
  }

  return {
    value: jobTitle,
    label: jobTitle,
    data: jobType
      ? {
          position: jobTitle,
          type: jobType,
          isPrefilled: true,
        }
      : {
          position: jobTitle,
          type: 'Specialist',
        },
  };
};
